export const endpoint = window.location.href?.includes('localhost')
  ? 'http://localhost:5000'
  : window.location.origin;

export const getConfig = () => ({
  authUrl: `${endpoint}/v1/auth`,
  productUrl: `${endpoint}/v1/products`,
  orderUrl: `${endpoint}/v1/order`,
});

export const transportCharges = 1;
